__webpack_require__.p = "/wp-content/plugins/svt-petition/st-react-form/build/";